/* Fit-Finder-Quiz — deterministische Größen-/Längenempfehlung.
   Alles über document-Delegation, weil basic-modal das Quiz beim Öffnen ans
   <body> verschiebt (requiresBodyAppended). Der Ursprungs-Picker wird beim
   Trigger-Klick gemerkt, damit der CTA im richtigen variant-selects wählt
   (PDP und Quick-View können gleichzeitig existieren).

   Teile (seit 29.10.26): Das Quiz besteht aus .fit-quiz-piece-Blöcken
   (snippets/fit-quiz-piece.liquid). Einzelprodukt = genau ein Teil, Set
   (data-fq-set="true", Metafeld custom.set_components) = ein Teil je
   Größen-Option mit dem Fit-Profil des Komponenten-Produkts. Im Set geht die
   Kundin die Teile nacheinander durch (Stepper), der CTA setzt am Ende alle
   Größen (plus Länge) im Picker. Fehlt .fit-quiz-piece (gecachtes Alt-Markup),
   gilt das Modal selbst als einziger Teil. */
(function () {
  'use strict';

  var sourcePickers = {}; // modalId -> variant-selects Element

  function modalRoot(el) {
    return el.closest('.fit-quiz-modal');
  }

  function isSet(modal) {
    return !!modal && modal.getAttribute('data-fq-set') === 'true';
  }

  function pieceEls(modal) {
    if (!modal) return [];
    var list = modal.querySelectorAll('.fit-quiz-piece');
    return list.length ? Array.prototype.slice.call(list) : [modal];
  }

  function getData(piece, modal) {
    modal = modal || modalRoot(piece) || piece;
    var i18nEl = modal.querySelector('[data-fq-i18n]');
    var metaEl = piece.querySelector('[data-fq-meta]');
    var meta = {};
    if (metaEl) {
      try { meta = JSON.parse(metaEl.textContent) || {}; } catch (e) { meta = {}; }
    }
    return {
      sizes: JSON.parse(piece.dataset.fqSizes || '[]'),
      optionName: piece.dataset.fqOptionName || 'Size',
      lengthOption: piece.dataset.fqLengthOption || '',
      // Echte Options-Werte aus Liquid (lokalisiert: Tall/Lang, Regular/Normal).
      tallValue: piece.dataset.fqTallValue || 'Tall',
      regularValue: piece.dataset.fqRegularValue || 'Regular',
      profile: piece.dataset.fqProfile || 'true',
      // Antwort-Mapping: pro Produkt via custom.quiz_*-Dropdowns übersteuerbar,
      // sonst in Liquid aus dem Fit-Profil abgeleitet.
      map: JSON.parse(piece.dataset.fqMap || '{"snug":0,"true":0,"loose":1,"between":"auto"}'),
      i18n: i18nEl ? JSON.parse(i18nEl.textContent) : {},
      // Kuratierte Fit-Metafelder (lokalisiert) des Produkts DIESES Teils:
      // fit1 = Schnitt-Aussage (custom.fit_recommendation), fit2 = "Label:
      // Aktion"-Zeilen für die Fit-Guidance (custom.fit_recommendation_2).
      fit1: String(meta.fit1 || '').trim(),
      fit2: String(meta.fit2 || ''),
      label: piece.getAttribute('data-fq-label') || ''
    };
  }

  function answer(piece, group) {
    var input = piece.querySelector('input[name="fq-' + group + '-' + piece.getAttribute('data-fq-uid') + '"]:checked');
    return input ? input.value : null;
  }

  function answersOf(piece) {
    return {
      usual_size: answer(piece, 'size'),
      fit: answer(piece, 'fit'),
      boob: answer(piece, 'boob'),
      between: answer(piece, 'between'),
      height: answer(piece, 'height')
    };
  }

  function betweenDelta(map, fit) {
    if (map.between === 'auto') return fit === 'snug' ? 0 : 1;
    return Number(map.between) || 0;
  }

  function boobDelta(data, a) {
    if (!a.boob || !data.map.boob || data.map.boob[a.boob] == null) return NaN;
    return Number(data.map.boob[a.boob]);
  }

  // "Zwischen zwei Größen" ist KEINE zusätzliche Stufe, sondern die Aussage
  // "meine echte Größe liegt zwischen der gewählten und der nächstgrößeren".
  // Wer zwischen S und M steht, bekommt deshalb bei einem Größer-Wunsch M und
  // nicht L — vorher wurden Fit-Delta und Zwischengrößen-Regel addiert
  // (Kathrin 28.8.2026). Spiegelbildlich gilt: bei einem Kleiner-Wunsch S und
  // nicht XS (der Satz "bleib bei der kleineren" empfahl bis dahin XS).
  // Erst ein Fit-Wunsch über eine Stufe hinaus verlässt das Größen-Paar.
  // Ohne Fit-/Cup-Wunsch entscheidet weiter die Produkt-Regel (auto | 0 | 1).
  function combineDelta(pref, btw, isBetween) {
    if (!isBetween) return pref;
    if (pref > 0) return Math.max(pref, 1);
    if (pref < 0) return Math.min(pref + 1, 0);
    return btw;
  }

  function recommend(data, a) {
    var i = data.sizes.indexOf(a.size);
    if (i < 0) return null;
    var pref = Number(data.map[a.fit]);
    if (isNaN(pref)) pref = 0;
    // Cup-/Boob-Größe verschiebt zusätzlich, analog zur Fit-Wahl.
    var bd = boobDelta(data, a);
    if (!isNaN(bd)) pref += bd;
    i += combineDelta(pref, betweenDelta(data.map, a.fit), a.between === 'yes');
    var clamped = '';
    if (i < 0) { i = 0; clamped = 'min'; }
    if (i > data.sizes.length - 1) { i = data.sizes.length - 1; clamped = 'max'; }
    return {
      size: data.sizes[i],
      length: data.lengthOption ? (a.height === 'tall' ? data.tallValue : data.regularValue) : '',
      clamped: clamped
    };
  }

  function recLabel(rec) {
    return rec.size + (rec.length ? ' · ' + rec.length : '');
  }

  function asSentence(s) {
    s = String(s || '').trim();
    if (!s) return '';
    return /[.!?…]$/.test(s) ? s : s + '.';
  }

  // Richtung einer fit_recommendation_2-Aktion (DE + EN), damit sich jede
  // Guidance-Zeile der Größenänderung zuordnen lässt, die zur Fit-Wahl gehört.
  function actionDir(action) {
    var s = String(action || '').toLowerCase();
    if (/size down|größe kleiner|grösse kleiner|nummer kleiner|kleiner|runter/.test(s)) return 'down';
    if (/size up|größe größer|grösse grösser|nummer größer|größer|grösser|hoch/.test(s)) return 'up';
    if (/regular|true to size|gewohnte größe|gewohnte grösse|normal|selbe|gleiche/.test(s)) return 'same';
    return null;
  }

  // fit_recommendation_2 in {label, dir}-Zeilen zerlegen ("Label: Aktion").
  function fit2Lines(data) {
    return String(data.fit2 || '')
      .replace(/\r\n?/g, '\n')
      .split('\n')
      .map(function (l) { return l.trim(); })
      .filter(Boolean)
      .map(function (line) {
        var idx = line.indexOf(':');
        return {
          label: idx > 0 ? line.slice(0, idx).trim() : '',
          dir: actionDir(idx > 0 ? line.slice(idx + 1) : line)
        };
      });
  }

  // Empfehlungstext aus den kuratierten Fit-Metafeldern bauen, statt aus
  // generischen Bausteinen (die dem echten Schnitt widersprechen konnten,
  // z.B. "fits true to size" bei "Cup runs large"). Kathrin 14.7.2026.
  function buildReason(data, a, rec) {
    var t = data.i18n;
    var parts = [];

    // 1. Schnitt-Charakter aus fit_recommendation. Ohne Metafeld greift die
    //    frühere generische Aussage als Fallback.
    if (data.fit1) {
      parts.push(asSentence(data.fit1));
    } else {
      parts.push(data.profile === 'relaxed' ? t.reason_relaxed : t.reason_true);
    }

    // 2. Konkrete Empfehlung: gewohnte Größe -> empfohlene Größe.
    var fromI = data.sizes.indexOf(a.size);
    var toI = data.sizes.indexOf(rec.size);
    if (toI === fromI) {
      if (t.rec_same) parts.push(t.rec_same.replace('%from%', a.size));
    } else if (t.rec_change) {
      parts.push(t.rec_change.replace('%from%', a.size).replace('%to%', rec.size));
    }

    // 3. Gegen-Hinweis aus fit_recommendation_2: die Option, die NICHT der aus
    //    der aktiven Frage folgenden Richtung entspricht ("Größerer Cup? ..."). Nur
    //    wenn es eine echte Alternative gibt, sonst würde es die Empfehlung doppeln.
    //    Ist die Cup-Frage aktiv (z.B. Cami Top), gibt sie die Richtung vor, weil
    //    fit_recommendation_2 dort die Cup-Fälle beschreibt; sonst die Fit-Wahl.
    var primaryDelta = boobDelta(data, a);
    if (isNaN(primaryDelta)) primaryDelta = Number(data.map[a.fit]);
    var fitDir = isNaN(primaryDelta) || primaryDelta === 0 ? 'same' : primaryDelta < 0 ? 'down' : 'up';
    var lines = fit2Lines(data);
    var others = lines.filter(function (l) { return l.label && l.dir && l.dir !== fitDir && !/between|zwischen/i.test(l.label); });
    if (lines.length && others.length && others.length < lines.length) {
      others.forEach(function (l) {
        var tmpl = l.dir === 'down' ? t.fit2_down : l.dir === 'up' ? t.fit2_up : t.fit2_same;
        if (tmpl) parts.push(tmpl.replace('%label%', l.label));
      });
    }

    // 4. Zwischen zwei Größen / Länge / Grenzen (unverändert).
    // Den Zwischengrößen-Satz ans tatsächliche Ergebnis koppeln, nicht an die
    // Roh-Regel: sonst stand "nimm die größere" über einer kleineren Empfehlung.
    // Führt der Fit-Wunsch unter das Größen-Paar, entfällt der Satz ganz.
    if (a.between === 'yes' && toI >= fromI) {
      parts.push(toI > fromI ? t.reason_between_up : t.reason_between_down);
    }
    // Länge: gegen den Antwortwert vergleichen, nicht gegen das Options-Label.
    // rec.length ist lokalisiert (EN Tall / DE Lang), der frühere Literal-
    // Vergleich === 'Tall' zeigte auf /de bei Lang-Empfehlung fälschlich den
    // Normal-Text (Bugfix 08/2026).
    if (rec.length) {
      parts.push(a.height === 'tall' ? t.reason_tall : t.reason_regular);
    }
    if (rec.clamped === 'min') parts.push(t.reason_min);
    if (rec.clamped === 'max') parts.push(t.reason_max);
    return parts.filter(Boolean).join(' ');
  }

  // Antworten + Empfehlung eines Teils. Fit-Frage kann pro Produkt komplett
  // ausgeblendet sein ('Hide this option' auf allen dreien) — dann trägt sie
  // NICHTS zur Größe bei (die Cup-Frage oder die Voreinstellung übernehmen).
  // fit=null => kein Fit-Delta in recommend.
  function pieceState(piece, modal) {
    var data = getData(piece, modal);
    var a = {
      size: answer(piece, 'size'),
      fit: answer(piece, 'fit'),
      boob: answer(piece, 'boob'),
      between: answer(piece, 'between'),
      height: answer(piece, 'height')
    };
    var needFit = !!piece.querySelector('input[name^="fq-fit-"]');
    if (!needFit) a.fit = null;
    var needBoob = !!piece.querySelector('input[name^="fq-boob-"]');
    var complete = !(!a.size || (needFit && !a.fit) || (needBoob && !a.boob) || !a.between || (data.lengthOption && !a.height));
    var rec = complete ? recommend(data, a) : null;
    return { el: piece, data: data, a: a, rec: rec, complete: !!rec };
  }

  // Set-Stepper: genau ein Teil ist aktiv (Fragen offen), Teile davor (und
  // bereits erreichte, vollständige Teile danach) zeigen eine Zusammenfassung
  // mit "Ändern", noch nicht erreichte Teile sind versteckt.
  function renderSteps(modal, states) {
    var last = states.length - 1;
    var active = Math.min(Number(modal.getAttribute('data-fq-active')) || 0, last);
    var reached = Math.max(Number(modal.getAttribute('data-fq-reached')) || 0, active);
    states.forEach(function (s, i) {
      var p = s.el;
      var isActive = i === active;
      var isDone = !isActive && (i < active || (i <= reached && s.complete));
      p.hidden = !isActive && !isDone;
      p.classList.toggle('is-active', isActive);
      p.classList.toggle('is-done', isDone);
      var head = p.querySelector('[data-fq-head]');
      var qs = p.querySelector('[data-fq-questions]');
      var sum = p.querySelector('[data-fq-summary]');
      var next = p.querySelector('[data-fq-next]');
      if (head) head.hidden = !isActive;
      if (qs) qs.hidden = !isActive;
      if (sum) {
        sum.hidden = !isDone;
        var txt = sum.querySelector('[data-fq-summary-text]');
        if (txt) txt.textContent = s.data.label + (s.rec ? ': ' + recLabel(s.rec) : '');
      }
      if (next) next.hidden = !(isActive && s.complete && i < last);
    });
  }

  function update(modal) {
    var result = modal.querySelector('[data-fq-result]');
    if (!result) return;
    var set = isSet(modal);
    var states = pieceEls(modal).map(function (p) { return pieceState(p, modal); });
    modal.__fqStates = states;
    if (set) renderSteps(modal, states);

    var allDone = states.length > 0 && states.every(function (s) { return s.complete; });
    var reached = Number(modal.getAttribute('data-fq-reached')) || 0;
    if (!allDone || (set && reached < states.length - 1)) {
      result.hidden = true;
      return;
    }

    // Je Teil eine Ergebniszeile; Alt-Markup ohne Zeilen = das Ergebnis selbst.
    var rows = result.querySelectorAll('[data-fq-result-row]');
    states.forEach(function (s, i) {
      var row = rows[i] || result;
      var out = row.querySelector('[data-fq-size-out]');
      var why = row.querySelector('[data-fq-reason]');
      if (out) out.textContent = recLabel(s.rec);
      if (why) why.textContent = buildReason(s.data, s.a, s.rec);
    });

    var cta = modal.querySelector('[data-fq-cta]');
    var t = states[0].data.i18n;
    var first = states[0].rec;
    var lenState = states.filter(function (s) { return !!s.rec.length; })[0];
    // data-fq-rec: alle Teile für den CTA. data-fq-rec-size/-length bleiben
    // (Teil 0 bzw. das Teil mit Länge) für size-unconfirmed.js + tos-datalayer.js.
    cta.dataset.fqRec = JSON.stringify(states.map(function (s) {
      return { option: s.data.optionName, size: s.rec.size, lengthOption: s.data.lengthOption, length: s.rec.length };
    }));
    cta.dataset.fqRecSize = first.size;
    cta.dataset.fqRecLength = lenState ? lenState.rec.length : first.length;
    cta.textContent = set && t.cta_set
      ? t.cta_set
      : t.cta.replace('%s', first.size + (first.length ? ', ' + first.length : ''));
    result.hidden = false;
  }

  // Inhalt des Quiz-Fensters so scrollen, dass das Teil oben steht.
  function scrollToPiece(modal, piece) {
    var body = modal.querySelector('.fit-quiz-body');
    if (!body || !piece || !piece.getBoundingClientRect) return;
    var delta = piece.getBoundingClientRect().top - body.getBoundingClientRect().top;
    body.scrollTop = Math.max(0, body.scrollTop + delta - 8);
  }

  function activate(modal, idx) {
    var reached = Number(modal.getAttribute('data-fq-reached')) || 0;
    modal.setAttribute('data-fq-active', String(idx));
    modal.setAttribute('data-fq-reached', String(Math.max(reached, idx)));
    update(modal);
    scrollToPiece(modal, pieceEls(modal)[idx]);
  }

  // Length-Werte sind lokalisiert (EN Tall/Regular, DE Lang/Normal); Size-Twin-Daten
  // können historische EN-Werte gegen DE-Radios klicken — deshalb Äquivalenz-Map.
  var LEN_EQ = { tall: 'lang', lang: 'tall', regular: 'normal', normal: 'regular' };
  function clickOptionRadio(picker, optionName, value) {
    if (!picker || !optionName || !value) return false;
    var wanted = String(value).toLowerCase();
    var inputs = picker.querySelectorAll('input[type="radio"]');
    for (var k = 0; k < inputs.length; k++) {
      var val = inputs[k].value.toLowerCase();
      if (inputs[k].name.indexOf(optionName) !== -1 && (inputs[k].value === value || val === wanted || val === LEN_EQ[wanted])) {
        if (!inputs[k].checked) inputs[k].click();
        return true;
      }
    }
    return false;
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    // Model-Size-Kachel auf dem Galeriebild (snippets/model-size-tile.liquid).
    // Sie kennt die Modal-ID nicht: die haengt an der block.id des Variant-Pickers,
    // und die Galerie rendert in einem eigenen Snippet ohne Zugriff darauf. Statt
    // die ID zu raten, klicken wir den echten Quiz-Trigger im selben .product —
    // damit laufen Theme-Modal-Binding, sourcePickers und restoreAnswers wie sonst.
    var msTile = e.target.closest('[data-model-size-tile]');
    if (msTile) {
      e.preventDefault();
      var msHost = msTile.closest('.product') || document;
      var msRef =
        msHost.querySelector('.open-fit-quiz[aria-controls]:not([hidden])') ||
        msHost.querySelector('.open-fit-quiz[aria-controls]');
      if (msRef) msRef.click();
      return;
    }

    var trigger = e.target.closest('.open-fit-quiz');
    if (trigger) {
      var id = trigger.getAttribute('aria-controls');
      var picker = trigger.closest('variant-selects');
      if (id && picker) sourcePickers[id] = picker;
      // Kathrin 14.7.: Wiederöffnen (v.a. über den "Deine Größe"-Chip) zeigt
      // das Quiz mit den zuletzt gegebenen Antworten statt leer.
      var openedModal = id ? document.getElementById(id) : null;
      if (openedModal) {
        restoreAnswers(openedModal);
        // Das Theme bindet Modal-Trigger nur einmal beim Load (connectedCallback
        // sammelt [aria-controls]-Buttons). Chip und "Finde deine Größe"-Link
        // leben in der Picker-Legend, die beim Variantenwechsel server-frisch
        // ersetzt wird — neu erzeugte Trigger sind dann taub. Delegiert
        // nachöffnen, falls der Theme-Listener nicht schon geöffnet hat.
        window.setTimeout(function () {
          if (!openedModal.hasAttribute('open') && typeof openedModal.show === 'function') {
            openedModal.show();
          }
        }, 0);
      }
      return;
    }

    var chartLink = e.target.closest('.fit-quiz-sizechart-link');
    if (chartLink) {
      // theme.js öffnet das Size-Chart-Modal selbst über aria-controls —
      // wir schließen nur das Quiz, damit nicht zwei Modals stapeln.
      var quizModal = modalRoot(chartLink);
      if (quizModal) {
        var quizClose = quizModal.querySelector('.drawer__close-btn');
        if (quizClose) quizClose.click();
      }
      return;
    }

    // Set-Stepper: "Weiter zu <Teil>" übernimmt gewohnte Größe und
    // "zwischen zwei Größen" ins nächste Teil, falls dort noch leer (änderbar).
    var nextBtn = e.target.closest('[data-fq-next]');
    if (nextBtn) {
      var nModal = modalRoot(nextBtn);
      var nPiece = nextBtn.closest('.fit-quiz-piece');
      if (!nModal || !nPiece) return;
      var nPieces = pieceEls(nModal);
      var nIdx = nPieces.indexOf(nPiece);
      var target = nPieces[nIdx + 1];
      if (!target) return;
      setQuizRadio(target, 'size', answer(nPiece, 'size'));
      setQuizRadio(target, 'between', answer(nPiece, 'between'));
      activate(nModal, nIdx + 1);
      return;
    }

    var changeBtn = e.target.closest('[data-fq-change]');
    if (changeBtn) {
      var cModal = modalRoot(changeBtn);
      var cPiece = changeBtn.closest('.fit-quiz-piece');
      if (!cModal || !cPiece) return;
      activate(cModal, pieceEls(cModal).indexOf(cPiece));
      return;
    }

    var restart = e.target.closest('[data-fq-restart]');
    if (restart) {
      var modal = modalRoot(restart);
      if (!modal) return;
      var inputs = modal.querySelectorAll('input[type="radio"]');
      for (var k = 0; k < inputs.length; k++) inputs[k].checked = false;
      var result = modal.querySelector('[data-fq-result]');
      if (result) result.hidden = true;
      if (isSet(modal)) {
        modal.setAttribute('data-fq-reached', '0');
        activate(modal, 0);
      }
      return;
    }

    var cta = e.target.closest('[data-fq-cta]');
    if (cta) {
      var modal2 = modalRoot(cta);
      if (!modal2) return;
      var source = sourcePickers[modal2.id] || document.querySelector('variant-selects');
      var recs = null;
      try { recs = JSON.parse(cta.dataset.fqRec || 'null'); } catch (err) { recs = null; }
      if (!recs || !recs.length) {
        var d0 = getData(pieceEls(modal2)[0], modal2);
        recs = [{ option: d0.optionName, size: cta.dataset.fqRecSize, lengthOption: d0.lengthOption, length: cta.dataset.fqRecLength }];
      }
      recs.forEach(function (r) {
        clickOptionRadio(source, r.option, r.size);
        if (r.lengthOption && r.length) clickOptionRadio(source, r.lengthOption, r.length);
      });
      var closeBtn = modal2.querySelector('.drawer__close-btn');
      if (closeBtn) closeBtn.click();
    }
  });

  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.closest) return;
    var modal = e.target.closest('.fit-quiz-modal');
    if (modal && e.target.matches('input[type="radio"]')) update(modal);
  });

  // --- Size Twin: produktbezogenes Größenprofil + Chip in der Fit-Note-Zeile ---
  // Chip erscheint NUR beim Produkt, für das das Quiz gemacht wurde (Kathrins
  // Vorgabe); die empfohlene Größe wird dann im Picker vorausgewählt.
  // Set: Eintrag trägt zusätzlich pieces[{option, size, length, answers}],
  // size/length/answers spiegeln Teil 0 (bzw. die Länge des Teils mit Länge).
  var LS_TWIN = 'tos_size_twin';

  function readTwinAll() {
    try {
      var raw = JSON.parse(window.localStorage.getItem(LS_TWIN) || 'null');
      if (raw && raw.products && typeof raw.products === 'object') return raw;
    } catch (e) {}
    return { v: 2, products: {} }; // v1-Altformat (global) bewusst verwerfen
  }
  function readTwinFor(handle) {
    if (!handle) return null;
    var e = readTwinAll().products[handle];
    return e && e.size ? e : null;
  }
  function writeTwinFor(handle, entry) {
    if (!handle) return;
    var all = readTwinAll();
    all.products[handle] = entry;
    try { window.localStorage.setItem(LS_TWIN, JSON.stringify(all)); } catch (e) {}
  }

  // Beim Öffnen des Quiz die zuletzt gespeicherten Antworten (Twin) in die
  // Radios zurückspielen. Nur Gruppen füllen, die in dieser Session noch leer
  // sind — eine laufende, bewusst geänderte Auswahl wird nicht zurückgesetzt.
  // checked per JS feuert kein change-Event, deshalb update() direkt (so wird
  // auch der Twin nicht unnötig neu geschrieben).
  function setQuizRadio(piece, group, value) {
    if (!value) return false;
    if (answer(piece, group)) return false;
    var inputs = piece.querySelectorAll('input[name="fq-' + group + '-' + piece.getAttribute('data-fq-uid') + '"]');
    for (var k = 0; k < inputs.length; k++) {
      if (inputs[k].value === value) {
        inputs[k].checked = true;
        return true;
      }
    }
    return false;
  }

  function restoreAnswers(modal) {
    var twin = readTwinFor(modal.getAttribute('data-fq-product-handle'));
    if (!twin) return;
    var set = isSet(modal);
    var pieces = pieceEls(modal);
    var restored = false;
    pieces.forEach(function (p, i) {
      var ans = set ? (twin.pieces && twin.pieces[i] && twin.pieces[i].answers) : twin.answers;
      if (!ans) return;
      if (setQuizRadio(p, 'size', ans.usual_size)) restored = true;
      if (setQuizRadio(p, 'fit', ans.fit)) restored = true;
      if (setQuizRadio(p, 'boob', ans.boob)) restored = true;
      if (setQuizRadio(p, 'between', ans.between)) restored = true;
      if (setQuizRadio(p, 'height', ans.height)) restored = true;
    });
    if (!restored) return;
    if (set) {
      // Stepper auf das erste offene Teil stellen; alles beantwortet = letztes
      // Teil aktiv, Ergebnis sofort sichtbar.
      var firstOpen = -1;
      for (var k = 0; k < pieces.length; k++) {
        if (!pieceState(pieces[k], modal).complete) { firstOpen = k; break; }
      }
      var target = firstOpen === -1 ? pieces.length - 1 : firstOpen;
      var reached = Number(modal.getAttribute('data-fq-reached')) || 0;
      modal.setAttribute('data-fq-active', String(target));
      modal.setAttribute('data-fq-reached', String(Math.max(reached, target)));
    }
    update(modal);
  }

  // Ziel-Optionen für die Vorauswahl im Picker: je Teil Größe (+ Länge).
  function twinTargets(modal, twin) {
    var pieces = pieceEls(modal);
    if (isSet(modal) && twin.pieces && twin.pieces.length) {
      return twin.pieces.map(function (tp, i) {
        var d = pieces[i] ? getData(pieces[i], modal) : null;
        return {
          option: (d && d.optionName) || tp.option,
          size: tp.size,
          lengthOption: d ? d.lengthOption : '',
          length: tp.length || ''
        };
      });
    }
    var data = getData(pieces[0], modal);
    return [{ option: data.optionName, size: twin.size, lengthOption: data.lengthOption, length: twin.length }];
  }

  // Einmal-Guard pro Seitenaufruf und Produkt — bewusst NICHT im DOM: der
  // Variantenwechsel rerendert die Picker-Legend samt Chip, ein DOM-Attribut
  // ginge verloren und die Vorauswahl würde manuelle Klicks zurücksetzen.
  var preselectedOnce = {};

  function preselect(chip, twin) {
    var handle = chip.getAttribute('data-fq-product-handle') || '';
    if (preselectedOnce[handle]) return;
    preselectedOnce[handle] = true;
    // Kathrin 13.7.: Die gespeicherte Größe gewinnt IMMER — auch bei
    // Out-of-stock und auch gegen ?variant=-Links (die Farbe des Links
    // bleibt erhalten, nur Größe/Länge werden gesetzt).
    var modal = document.getElementById(chip.getAttribute('aria-controls') || '');
    if (!modal) return;
    var targets;
    try { targets = twinTargets(modal, twin); } catch (e) { return; }
    var scope = chip.closest('product-info') || chip.closest('.product__info-container') || document;
    var picker = scope.querySelector('variant-selects') || document.querySelector('variant-selects');
    if (!picker) return;
    var tries = 0;
    (function attempt() {
      var ok = clickOptionRadio(picker, targets[0].option, targets[0].size);
      if (ok) {
        targets.forEach(function (t, i) {
          if (i > 0) clickOptionRadio(picker, t.option, t.size);
          if (t.lengthOption && t.length) clickOptionRadio(picker, t.lengthOption, t.length);
        });
      }
      if (!ok && ++tries < 4) window.setTimeout(attempt, 400);
    })();
  }

  function copyOf(obj) {
    var out = {};
    for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k)) out[k] = obj[k];
    return out;
  }

  // Gespeicherte Empfehlung gegen die aktuelle Logik nachrechnen. Wer das Quiz
  // vor dem Zwischengrößen-Fix (28.8.2026) gemacht hat, trägt eine zu große
  // Größe im Twin — Chip und Vorauswahl im Picker würden sie weiter anbieten,
  // obwohl das Quiz inzwischen anders rechnet. Die Antworten liegen im Twin,
  // also einmal neu rechnen und still korrigieren. Greift genauso, wenn Kathrin
  // die quiz_*-Metafelder eines Produkts ändert. Im Set je Teil.
  function recalc(piece, modal, ans) {
    if (!piece || !ans || !ans.usual_size) return null;
    var data;
    try { data = getData(piece, modal); } catch (e) { return null; }
    return recommend(data, {
      size: ans.usual_size,
      fit: ans.fit || null,
      boob: ans.boob || null,
      between: ans.between,
      height: ans.height
    });
  }

  function refreshTwin(chip, twin) {
    var modal = document.getElementById(chip.getAttribute('aria-controls') || '');
    if (!modal) return twin;
    var pieces = pieceEls(modal);
    var handle = chip.getAttribute('data-fq-product-handle');
    if (isSet(modal)) {
      if (!twin.pieces || !twin.pieces.length) return twin;
      var changed = false;
      var newPieces = twin.pieces.map(function (tp, i) {
        var rec = tp ? recalc(pieces[i], modal, tp.answers) : null;
        if (!rec || (rec.size === tp.size && (rec.length || '') === (tp.length || ''))) return tp;
        changed = true;
        var np = copyOf(tp);
        np.size = rec.size;
        np.length = rec.length || '';
        return np;
      });
      if (!changed) return twin;
      var fixedSet = copyOf(twin);
      var lenP = newPieces.filter(function (p) { return p && p.length; })[0];
      fixedSet.pieces = newPieces;
      fixedSet.size = newPieces[0].size;
      fixedSet.length = lenP ? lenP.length : '';
      writeTwinFor(handle, fixedSet);
      return fixedSet;
    }
    if (!twin.answers || !twin.answers.usual_size) return twin;
    var rec0 = recalc(pieces[0], modal, twin.answers);
    if (!rec0 || (rec0.size === twin.size && (rec0.length || '') === (twin.length || ''))) return twin;
    var fixed = copyOf(twin);
    fixed.size = rec0.size;
    fixed.length = rec0.length || '';
    writeTwinFor(handle, fixed);
    return fixed;
  }

  function hydrateChips() {
    document.querySelectorAll('[data-fq-mysize]').forEach(function (chip) {
      var label = chip.querySelector('[data-fq-mysize-label]');
      if (!label) return;
      // Set: der Chip einer Größen-Option zeigt die Größe SEINES Teils.
      var pieceAttr = chip.getAttribute('data-fq-piece');
      // Priorität (Kathrins Regel): produktbezogenes Quiz (localStorage) schlägt
      // die server-gerenderte Behalten-Historie aus dem Metafeld.
      var twin = readTwinFor(chip.getAttribute('data-fq-product-handle'));
      if (twin) {
        twin = refreshTwin(chip, twin);
        var shown = pieceAttr === null ? twin : (twin.pieces && twin.pieces[Number(pieceAttr)]);
        if (shown && shown.size) {
          label.textContent =
            (chip.getAttribute('data-fq-mysize-prefix') || '') + shown.size + (shown.length ? ' · ' + shown.length : '');
          chip.hidden = false;
          preselect(chip, twin);
          return;
        }
      }
      if (pieceAttr !== null) return;
      var srvSize = chip.getAttribute('data-fq-server-size');
      if (srvSize) {
        chip.hidden = false; // Label ist bereits server-gerendert
        preselect(chip, { size: srvSize, length: chip.getAttribute('data-fq-server-length') || '' });
      }
    });
  }

  // Quiz-Ergebnis produktbezogen merken, sobald es berechnet wurde
  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.closest) return;
    var modal = e.target.closest('.fit-quiz-modal');
    if (!modal || !e.target.matches('input[type="radio"]')) return;
    var cta = modal.querySelector('[data-fq-cta]');
    var result = modal.querySelector('[data-fq-result]');
    if (!cta || !result || result.hidden || !cta.dataset.fqRecSize) return;
    var handle = modal.getAttribute('data-fq-product-handle');
    var entry;
    if (isSet(modal)) {
      var states = modal.__fqStates || [];
      if (!states.length || !states.every(function (s) { return s.complete; })) return;
      var pieces = states.map(function (s) {
        return { option: s.data.optionName, size: s.rec.size, length: s.rec.length || '', answers: answersOf(s.el) };
      });
      var lenP = pieces.filter(function (p) { return !!p.length; })[0];
      entry = {
        size: pieces[0].size,
        length: lenP ? lenP.length : '',
        pieces: pieces,
        answers: pieces[0].answers,
        at: new Date().toISOString(),
        source: 'quiz'
      };
    } else {
      entry = {
        size: cta.dataset.fqRecSize,
        length: cta.dataset.fqRecLength || '',
        answers: answersOf(pieceEls(modal)[0]),
        at: new Date().toISOString(),
        source: 'quiz'
      };
    }
    writeTwinFor(handle, entry);
    hydrateChips();
    var done = modal.querySelector('[data-fq-save-done]');
    var saveBtn = modal.querySelector('[data-fq-save-btn]');
    if (done && saveBtn && !done.hidden) { done.hidden = true; saveBtn.hidden = false; saveBtn.disabled = false; }
  });

  // Save-to-Profile: Klaviyo-Event (Muster contact-form); die tägliche
  // Size-Engine übernimmt es von dort ins Shopify-Customer-Metafeld.
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('[data-fq-save-btn]');
    if (!btn) return;
    var modal = modalRoot(btn);
    if (!modal) return;
    var handle = modal.getAttribute('data-fq-product-handle');
    var twin = readTwinFor(handle);
    if (!twin || !twin.size) return;
    var setPieces = isSet(modal) && twin.pieces && twin.pieces.length ? twin.pieces : null;
    btn.disabled = true;
    var props = {
      // Set: "S + L" (Größen der Teile in Picker-Reihenfolge), Details in pieces.
      recommended_size: setPieces ? setPieces.map(function (p) { return p.size; }).join(' + ') : twin.size,
      recommended_length: twin.length || '',
      usual_size: (twin.answers && twin.answers.usual_size) || '',
      fit_preference: (twin.answers && twin.answers.fit) || '',
      cup_size: (twin.answers && twin.answers.boob) || '',
      between_sizes: (twin.answers && twin.answers.between) || '',
      height: (twin.answers && twin.answers.height) || '',
      product_handle: handle || '',
      shopify_customer_id: btn.getAttribute('data-fq-customer-id') || ''
    };
    if (setPieces) props.pieces = JSON.stringify(setPieces);
    var payload = {
      data: {
        type: 'event',
        attributes: {
          properties: props,
          metric: { data: { type: 'metric', attributes: { name: 'Fit Quiz Completed' } } },
          profile: { data: { type: 'profile', attributes: { email: btn.getAttribute('data-fq-customer-email') || '' } } }
        }
      }
    };
    fetch('https://a.klaviyo.com/client/events/?company_id=V5n9WQ', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify(payload),
      keepalive: true
    })
      .then(function (res) {
        if (!(res.ok || res.status === 202)) throw new Error('event failed');
        btn.hidden = true;
        var done = modal.querySelector('[data-fq-save-done]');
        if (done) done.hidden = false;
      })
      .catch(function () {
        btn.disabled = false;
      });
  });

  hydrateChips();

  // Quick-View injiziert seinen Inhalt (samt Chip) erst nach dem Seitenload
  // per innerHTML — ein leichtes, idempotentes Interval hydriert nachzügelnde
  // Chips (schreibt nur bei leerem Label; Preselect feuert je Produkt einmal).
  window.setInterval(hydrateChips, 800);

  // Der FoxTheme-Variantenwechsel rerendert die Picker-Legend (samt Chip)
  // server-frisch — danach neu hydrieren (Preselect greift wegen Guard nicht).
  var fqPubsubTries = 0;
  (function fqSubscribe() {
    if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.subscribe && FoxTheme.pubsub.PUB_SUB_EVENTS) {
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, function () {
        window.setTimeout(hydrateChips, 80);
      });
    } else if (++fqPubsubTries < 25) {
      window.setTimeout(fqSubscribe, 400);
    }
  })();

  // Falls Antworten schon gesetzt wurden, bevor dieses Script geparst war
  // (sehr schnelle Interaktion / Tests): einmal nachrechnen.
  document.querySelectorAll('.fit-quiz-modal').forEach(function (m) { update(m); });
  window.__fitQuizReady = true;
})();
